module.exports = __webpack_public_path__ + "d5f37e527d40d98759c0a5684544b980.MP3";